import { useState, useEffect, useRef, createElement, forwardRef } from "react";
import './index.scss';
const ColorfulInput = forwardRef(({ label = '标题', placeholder = '输入文本', defaultValue, textAlign = 'left', password = false, required = false, separate = false, isHideLabel = false, allowClear, labelWidth, disabled, isError, onChange, ...otherProps }, ref) => {
    const inputClass = separate ? 'au-input-separate' : '';
    const alignClass = `au-input-${textAlign}`;
    const labelFixWidth = labelWidth ? `${labelWidth}px` : 'auto';
    const [showCancel, setShowCancel] = useState(allowClear);
    const inputRef = useRef(null);
    const statusClass = isError ? 'au-input-error' : '';
    const _otherProps = otherProps || {};
    const [inputValue, setInputValue] = useState(defaultValue);
    const handleChange = (e) => {
        const { value } = e.target;
        setInputValue(value);
        if (value) {
            if (!isError) {
                allowClear && setShowCancel(true);
            }
        }
        else {
            setShowCancel(false);
        }
        if (onChange) {
            onChange(e);
        }
    };
    const handleRemove = (e) => {
        setInputValue('');
        setShowCancel(false);
    };
    const handleFocus = () => {
        allowClear && setShowCancel(true);
    };
    const handleBlur = (e) => {
    };
    useEffect(() => {
        if (defaultValue?.length > 0) {
            setInputValue(defaultValue);
            allowClear && setShowCancel(true);
        }
        else {
            setShowCancel(false);
        }
    }, [defaultValue]);
    useEffect(() => {
        if (isError) {
            setShowCancel(false);
        }
    }, [isError]);
    useEffect(() => {
        if (allowClear) {
            setShowCancel(true);
        }
        else {
            setShowCancel(false);
        }
    }, [allowClear]);
    return (createElement("div", { className: `au-input ${inputClass} ${alignClass} ${statusClass}`, ..._otherProps },
        !isHideLabel && createElement("label", { className: 'inner-label', style: { width: labelFixWidth } },
            required ? createElement("span", { className: "required-title" }, "*") : '',
            label || '标题'),
        createElement("div", { className: 'inner-content' },
            createElement("input", { className: 'inner-input', placeholder: placeholder || '输入文本', value: inputValue, disabled: disabled, ref: ref || inputRef, onFocus: handleFocus, onBlur: handleBlur, onChange: handleChange, type: password ? 'password' : 'text' })),
        showCancel && createElement("i", { className: "icon-times-circle", onClick: handleRemove }),
        isError && createElement("i", { className: "icon-exclamation-circle" })));
});
ColorfulInput.displayName = 'ColorfulInput';
export default ColorfulInput;
